import { Suppliermanager } from '@linktivity/link-connect';
import configParams from '../config';

const config = new Suppliermanager.Configuration(configParams);
const accountApi = new Suppliermanager.SupplierAccountApi(config);

export default accountApi;
